import { Container, Grid } from '@mui/material';
import { t } from 'i18next';
import parse from 'html-react-parser';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { GET_ALL_SUBORDER } from 'src/apiService/apiDeclaration';
import PageHeader from 'src/components/pageHeader/PageHeader';
import CustomTable from 'src/components/table/table';
import TabTitle from 'src/components/tabTitle/tabTitle';
import { USER_ROLES } from 'src/config/enum';
import { subOrderTableColumns } from 'src/constants/columnConfig';
import usePagination from 'src/hooks/usePagination';
import { subOrderSortArray, subOrderStatusArray } from 'src/constants';
import CustomSelectField from 'src/components/formFields/selectField';

const SubOrderPage = () => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const status = location.state || '';
  const navigate = useNavigate();
  const [articleStatus, setArticleStatus] = useState(status ? status : 'default');
  const [sortDirection, setSortDirection] = useState('default');
  let params = { status: articleStatus === 'default' ? '' : articleStatus, deliveryDate: '' };
  const { paginationModel, setPaginationModel, loading, data, setQuerryParams } = usePagination(
    GET_ALL_SUBORDER,
    params
  );
  const updatedSubOrderTable = [...subOrderTableColumns];

  user.role !== USER_ROLES.OPERATOR &&
    updatedSubOrderTable.push({
      field: 'name',
      headerName: 'common.name',
      flex: 1,
      renderCell: ({ row }) =>
        row?.customerId?.firstName ? parse(row.customerId.firstName + ' ' + row.customerId.lastName) : '-',
    });

  const handleNavigate = (body) => {
    navigate('/order-details', { state: body });
  };

  // useEffect(() => {
  //   let status;
  //   if (articleStatus === 'default') {
  //     status = '';
  //   } else {
  //     status = articleStatus;
  //   }
  //   setQuerryParams({ ...params, status: status });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [articleStatus]);

  return (
    <Container>
      <Grid container spacing={2}>
        <TabTitle title={'Orders'} />
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: {
              xs: 'flex-start',
              sm: 'center',
            },
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
          }}
        >
          <PageHeader pageTitle={t('orderDetailsPage.subOrders')} />
          {user.role !== 'CUSTOMER' && (
            <Grid sx={{ display: 'flex', gap: 2 }}>
              <CustomSelectField
                value={sortDirection}
                onChange={(e) => {
                  setSortDirection(e.target.value);
                  setQuerryParams({ ...params, deliveryDate: e.target.value === 'default' ? '' : e.target.value });
                }}
                optionsArray={subOrderSortArray}
                label={t('labels.sortOrderItems')}
                sx={{ width: { sm: '200px', xs: '160px' } }}
              />
              <CustomSelectField
                value={articleStatus}
                onChange={(e) => {
                  setArticleStatus(e.target.value);
                  setQuerryParams({ ...params, status: e.target.value === 'default' ? '' : e.target.value });
                }}
                optionsArray={
                  user.role === USER_ROLES.OPERATOR
                    ? subOrderStatusArray.slice(2)
                    : [...subOrderStatusArray.slice(0, 1), ...subOrderStatusArray.slice(2)]
                }
                label={t('labels.filterOrderItemByStatus')}
                sx={{ width: { sm: '200px', xs: '160px' } }}
              />
            </Grid>
          )}
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            loading={loading}
            isServerSidePagination
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            columns={updatedSubOrderTable}
            rows={data?.rows}
            rowCount={data?.rowCount}
            handleNavigate={() => handleNavigate()}
            onRowClick={handleNavigate}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SubOrderPage;
